"use client";

import Config from "@/config";
import { useShopifyAnalytics } from "@/libraries/shopify/analytics";
import { AnalyticsEventName, useShopifyCookies } from "@shopify/hydrogen-react";
import { useEffect } from "react";

export default function ShopifyAnalytics() {

	const { sendPageView, pathname } = useShopifyAnalytics();

	const domain = Config.domain.replace(/https?:\/\//,'');

	console.log("ShopifyAnalytics", {
		pathname,
		sendPageView
	});

	console.log({
		hasUserConsent: true,
		domain: domain,
		checkoutDomain: `checkout.${ domain }`
	});

	//Set the cookies
	useShopifyCookies({
		hasUserConsent: true,
		domain: domain,
		checkoutDomain: `checkout.${ domain }`
	});

	useEffect(() => {
		sendPageView(AnalyticsEventName.PAGE_VIEW);
	}, [pathname, sendPageView]);
	return null;
}
